import { render, staticRenderFns } from "./billing-grid-actions-delivery-notes.vue?vue&type=template&id=5954b8bc&scoped=true&"
import script from "./billing-grid-actions-delivery-notes.ts?vue&type=script&lang=ts&"
export * from "./billing-grid-actions-delivery-notes.ts?vue&type=script&lang=ts&"
import style0 from "./billing-grid-actions-delivery-notes.scss?vue&type=style&index=0&id=5954b8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5954b8bc",
  null
  
)

export default component.exports